module.exports = "https://static.wmbcdn.com/uniweb/images/acb44add5d204e8d1330ead6c704fd06.svg";